//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
    venues_list,
    playingField_list,
    timeSlot_update,
    timeSlot_detail
} from '@/apis/stadium'
import { service_list } from '@/apis/product'
import TimeSpan from '@/components/TimeSpan.vue';

export default {
    components: {
        TimeSpan
    },
    data() {
        const rules = {
            name: [{ required: true, message: '請輸入場次名稱！' }],
            venueCode: [{ required: true, message: '請選擇所屬場館！' }],
            fieldCode: [{ required: true, message: '請選擇所屬場地！' }],
            serviceTypeCode: [{ required: true, message: '請選擇產品標籤！' }],
            serviceId: [{ required: true, message: '請選擇產品事件！' }],
            businessHours: [{ required: true, message: '請選擇時段！' }],
            status: [{ required: true, message: '請選擇狀態！' }],
            items: [{ required: true, message: '請選擇時間範圍！' }],
            date: [{ required: true, message: '請選擇日期！' }],
            type: [{ required: true, message: '請選擇票卷類型！' }],
            price: [{ required: true, message: '請選擇票卷金額！' }],
            timespan: [{ required: true, message: '請選擇時間範圍！' }],
        };

        const form = {
            name: null,
            venueCode: undefined,
            fieldCode: undefined,
            serviceTypeCode: undefined,
            serviceId: undefined,
            businessHours: undefined,
            date: '',
            type: '',
            price: '',
            timespan: ''
        };

        return {
            id: '',
            isLoading: false,
            config: {
                gymnasiums: [],
                fields: []
            },
            form,
            rules,
            labelCol: { style: { width: '150px', }, },
            wrapperCol: { span: 14, },
        };
    },
    async mounted() {
        this.id = this.$route.params.id;
        await this.onPageConfig();
        await this.onPageLoad();
    },
    methods: {
        async getVenues() {
            try {
                //加載所屬場館
                const res = await venues_list({ venueName: '', venueCode: '', venueState: '1', pageNumber: 1, pageSize: 999 }) || {};
                if (res.code == 0) {
                    this.config.gymnasiums = res.data.records;
                } else {
                    if (res.msg)
                        throw new Error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async getField() {
            try {
                const res = await playingField_list({ fieldName: '', venueCode: this.form.venueCode, status: 1, sportTypeCode: '', pageNumber: 1, pageSize: 999 });
                if (res.code == 0) {
                    this.config.fields = res.data.records;
                } else {
                    if (res.msg)
                        throw new Error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async onPageConfig() {
            await this.getVenues();
        },
        async getService() {
            try {
                const res = await service_list({ venueCode: this.form.venueCode, type: '', typeCode: this.form.serviceTypeCode, time: '', name: '', pageNumber: 1, pageSize: 999 }) || {};
                if (res.code == 0) {
                    this.config.services = res.data.records;
                } else {
                    if (res.msg)
                        throw new Error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async onPageLoad() {
            try {
                const res = await timeSlot_detail(this.id) || {};
                if (res.code == 0) {
                    const item = res.data || {};
                    const form = { ...this.form };
                    form.id = this.id;
                    form.name = item.name;
                    form.venueCode = item.venueCode;
                    form.fieldCode = item.fieldCode;
                    form.serviceTypeCode = item.serviceTypeCode;
                    form.serviceId = item.serviceId;
                    form.price = item.price;
                    form.date = item.time;
                    form.type = `${item.type == '0' ? '' : item.type}`;
                    form.timespan = `${item.startTime}-${item.endTime}`;

                    await this.getField();
                    await this.getService();
                    form.status = `${item.status}`;
                    this.form = form;
                } else {
                    if (res.msg) throw new Error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async handleGymnasiumChange() {
            this.form.fieldCode = '';
            await this.getField();
        },
        async handleServiceTypeChange() {
            this.form.serviceId = '';
            await this.getService();
        },
        handleOnFormValidate(e, v) {
            e.preventDefault();
            if (this.form.timespan) {
                const [start, end] = this.form.timespan.split('-');
                this.form.startTime = start ? this.$moment(start, 'HH:mm') : null;
                this.form.endTime = end ? this.$moment(end, 'HH:mm') : null;
            } else {
                this.form.startTime = null;
                this.form.endTime = null;
            }
            this.$refs.form.validate(valid => {
                console.log(valid);
                if (valid) {
                    this.onSubmit();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        handleOnChangeTimeSpan() {
            this.$refs.timespan.clearValidate();
        },

        // 提交表單
        async onSubmit() {
            try {
                this.isLoading = true;
                const res = await timeSlot_update(this.form) || {};
                if (res.code == 0) {
                    this.$message.success('提交完成');
                    this.$router.push('/matches-timeslot');
                } else {
                    if (res.msg)
                        throw new Error(res.msg)
                }
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.isLoading = false;
            }
        },
    }
};
